import { ErrorPayLoad, UpdateTenantMemberSuccessPayload, deleteTenantMemberSuccessPayload, getTenantMemberForUpdateSuccessPayload, getTenantMemberSoftPhoneDetailSuccessPayload, getTenentWebSiteDomainSuccessPayload } from "../interfaces/tenantMember"
import { Types } from "../types"
import { AddNewTenantError, AddNewTenantRequest, AddNewTenantSuccess, deleteTenantMemberError, deleteTenantMemberRequest, deleteTenantMemberSuccess, getAvailableInternalPhoneError, getAvailableInternalPhoneRequest, getAvailableInternalPhoneSuccess, getTenantMemberForUpdateError, getTenantMemberForUpdateRequest, getTenantMemberForUpdateSuccess, getTenantMemberSoftPhoneDetailError, getTenantMemberSoftPhoneDetailRequest, getTenantMemberSoftPhoneDetailSuccess, getTenantWebsiteDomainError, getTenantWebsiteDomainRequest, getTenantWebsiteDomainSuccess, resetDeleteTenantRequest, sendSoftPhoneDetailToTenantMemberError, sendSoftPhoneDetailToTenantMemberRequest, sendSoftPhoneDetailToTenantMemberSuccess, toggleTenantMemberStatusError, toggleTenantMemberStatusRequest, toggleTenantMemberStatusSuccess, updateTenantMemberError, updateTenantMemberRequest, updateTenantMemberSuccess } from "../types/tenantMember/actionTypes"
import { AddTenantMember, GetTenantMemberForUpdateResponse, IdTenant, TogglePayload, UpdateTenantMember, UpdateTenantMemberResponse } from "../types/tenantMember/tenantMemberApiRequestType"

//****************************************************** */
export const AddnewTenantRequestAction = (payload: AddTenantMember): AddNewTenantRequest => ({
    type: Types.ADD_NEW_TENANT_MEMBER_REQUEST,
    payload
})
export const AddnewTenantSuccessAction = (): AddNewTenantSuccess => ({
    type: Types.ADD_NEW_TENANT_MEMBER_SUCCESS
})

export const AddnewTenantErrorAction = (payload: ErrorPayLoad): AddNewTenantError => ({
    type: Types.ADD_NEW_TENANT_MEMBER_ERROR,
    payload
})
//******************************************************** */
export const getAvailableInternalPhoneRequestAction = (): getAvailableInternalPhoneRequest => ({
    type: Types.GET_AVAILABLE_INTERNAL_PHONE_REQUEST,
})

export const getAvailableInternalPhoneSuccessAction = (payload: any): getAvailableInternalPhoneSuccess => ({
    type: Types.GET_AVAILABLE_INTERNAL_PHONE_SUCCESS,
    payload
})

export const getAvailableInternalPhoneErrorAction = (payload: ErrorPayLoad): getAvailableInternalPhoneError => ({
    type: Types.GET_AVAILABLE_INTERNAL_PHONE_ERROR,
    payload
})

//******************************************************* */
export const updateTenantMemberRequestAction = (payload: UpdateTenantMember): updateTenantMemberRequest => ({
    type: Types.UPDATE_TENANT_MEMBER_REQUEST,
    payload
})

export const updateTenantMemberSuccessAction = (payload: UpdateTenantMemberSuccessPayload): updateTenantMemberSuccess => ({
    type: Types.UPDATE_TENANT_MEMBER_SUCCESS,
    payload
})

export const updateTenantMemberErrorAction = (payload: ErrorPayLoad): updateTenantMemberError => ({
    type: Types.UPDATE_TENANT_MEMBER_ERROR,
    payload
})
//********************************************************** */
export const deleteTenantMemberRequestAction = (payload: String): deleteTenantMemberRequest => ({
    type: Types.DELETE_TENANT_MEMBER_REQUEST,
    payload
})

export const deleteTenantMemberSuccessAction = (payload: deleteTenantMemberSuccessPayload): deleteTenantMemberSuccess => ({
    type: Types.DELETE_TENANT_MEMBER_SUCCESS,
    payload
})

export const deleteTenantMemberErrorAction = (payload: ErrorPayLoad): deleteTenantMemberError => ({
    type: Types.DELETE_TENANT_MEMBER_ERROR,
    payload
})
//******************************************************************* */
export const getTenantMemberForUpdateRequestAction = (payload: String): getTenantMemberForUpdateRequest => ({
    type: Types.GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_REQUEST,
    payload
})

export const getTenantMemberForUpdateSuccessAction = (payload: getTenantMemberForUpdateSuccessPayload): getTenantMemberForUpdateSuccess => ({
    type: Types.GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_SUCCESS,
    payload
})

export const getTenantMemberForUpdateErrorAction = (payload: ErrorPayLoad): getTenantMemberForUpdateError => ({
    type: Types.GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_ERROR,
    payload
})
//************************************************************************ */
export const getTenantMemberSoftPhoneDetailRequestAction = (payload: String): getTenantMemberSoftPhoneDetailRequest => ({
    type: Types.GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_REQUEST,
    payload
})

export const getTenantMemberSoftPhoneDetailSuccessAction = (payload:getTenantMemberSoftPhoneDetailSuccessPayload): getTenantMemberSoftPhoneDetailSuccess => ({
    type: Types.GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_SUCCESS,
    payload
})

export const getTenantMemberSoftPhoneDetailErrorAction = (payload: ErrorPayLoad): getTenantMemberSoftPhoneDetailError => ({
    type: Types.GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_ERROR,
    payload
})
//***************************************************************************** */
export const sendSoftPhoneDetailToTenantMemberRequestAction = (payload: IdTenant): sendSoftPhoneDetailToTenantMemberRequest => ({
    type: Types.SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_REQUEST,
    payload
})

export const sendSoftPhoneDetailToTenantMemberSuccessAction = (): sendSoftPhoneDetailToTenantMemberSuccess => ({
    type: Types.SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_SUCCESS,
    
})

export const sendSoftPhoneDetailToTenantMemberErrorAction = (payload: ErrorPayLoad): sendSoftPhoneDetailToTenantMemberError => ({
    type: Types.SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_ERROR,
    payload
})
//*********************************************************************************** */
export const toggleTenantMemberStatusRequestAction = (payload: TogglePayload): toggleTenantMemberStatusRequest => ({
    type: Types.TOGGLE_TENANT_MEMBER_STATUS_REQUEST,
    payload
})

export const toggleTenantMemberStatusSuccessAction = (): toggleTenantMemberStatusSuccess => ({
    type: Types.TOGGLE_TENANT_MEMBER_STATUS_SUCCESS,
})

export const toggleTenantMemberStatusErrorAction = (payload: ErrorPayLoad): toggleTenantMemberStatusError => ({
    type: Types.TOGGLE_TENANT_MEMBER_STATUS_ERROR,
    payload
})
//*************************************************************************************** */
export const getTenantWebsiteDomainRequestAction = (): getTenantWebsiteDomainRequest => ({
    type: Types.GET_TENANT_WEBSITE_DOMAIN_REQUEST,
   
})

export const getTenantWebsiteDomainSuccessAction = (payload:getTenentWebSiteDomainSuccessPayload): getTenantWebsiteDomainSuccess => ({
    type: Types.GET_TENANT_WEBSITE_DOMAIN_SUCCESS,
    payload
})

export const getTenantWebsiteDomainErrorAction = (payload: ErrorPayLoad): getTenantWebsiteDomainError => ({
    type: Types.GET_TENANT_WEBSITE_DOMAIN_ERROR,
    payload
})
///****************************************************************************** */
export const resetDeleteTenant = (): resetDeleteTenantRequest => ({
    type: Types.RESET_DELETE_TENANT,
})